export default __webpack_public_path__ + "static/media/ic_arrowright.21f2790a.svg";